var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTdBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 605,
    viewBox: "0 0 1920 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1114_3224)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 605,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.257 -69.6149C316.857 -57.2326 384.084 -74.9732 415.527 -30.6542C446.848 13.4904 414.388 79.2043 411.334 136.275C408.141 195.94 433.259 262.968 397.252 310.833C361.226 358.723 293.891 350.493 239.001 365.361C186.492 379.585 135.384 406.905 83.647 395.782C27.0215 383.607 -30.9786 355.424 -57.621 301.587C-83.7814 248.725 -60.4507 183.159 -51.8234 122.036C-43.8084 65.2511 -46.6195 2.10931 -9.26937 -40.9737C27.5065 -83.3944 85.6923 -91.7138 138.236 -97.1956C183.096 -101.876 222.092 -79.9733 265.257 -69.6149Z",
    fill: "#B831BB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.967 15.0893C30.3007 46.3747 16.7634 125.659 -40.7716 137.289C-98.8449 149.027 -148.047 97.7498 -201.387 71.9595C-261.755 42.7715 -336.054 32.6758 -372.943 -23.3183C-412.39 -83.1955 -413.719 -160.667 -401.151 -231.26C-388.074 -304.709 -364.008 -384.961 -301.346 -425.45C-240.488 -464.773 -161.874 -432.665 -89.417 -432.688C-24.9885 -432.708 38.7546 -448.402 99.0046 -425.577C168.239 -399.349 237.469 -360.912 272.381 -295.624C308.769 -227.575 329.56 -136.002 288.933 -70.3956C248.316 -4.80731 145.242 -26.0283 79.967 15.0893Z",
    fill: "#8936E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.915 79.4106C340.868 86.5293 297.322 30.6873 244.808 4.94783C184.326 -24.6973 100.906 -23.7756 68.2284 -82.6748C35.3398 -141.955 63.8948 -216.345 86.5962 -280.224C107.376 -338.694 141.533 -391.473 191.193 -428.681C238.767 -464.326 297.295 -478.743 356.619 -482.539C415.36 -486.298 476.777 -482.673 525.798 -450.092C573.985 -418.064 603.954 -364.419 618.57 -308.436C631.935 -257.243 619.138 -204.767 603.002 -154.379C587.937 -107.334 561.879 -67.1663 529.393 -29.9521C491.136 13.8721 456.656 72.3296 398.915 79.4106Z",
    fill: "#3E23E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M621.482 520.869C585.705 563.773 526.623 572.422 481.58 605.467C426.273 646.043 396.917 727.996 328.747 735.633C259.187 743.427 190.312 697.254 146.008 643.064C104.286 592.035 116.919 519.431 99.9159 455.747C81.066 385.145 1.1349 311.311 41.1001 250.132C83.026 185.952 192.304 241.287 261.529 208.351C323.186 179.015 342.391 84.1255 410.006 74.6128C479.238 64.8723 543.235 114.733 595.303 161.392C648.194 208.788 699.165 267.519 704.324 338.352C709.298 406.659 665.345 468.269 621.482 520.869Z",
    fill: "#E46B45"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1816.29 -43.5451C1867.89 -31.1628 1935.11 -48.9033 1966.56 -4.58437C1997.88 39.5603 1965.42 105.274 1962.36 162.345C1959.17 222.01 1984.29 289.037 1948.28 336.903C1912.25 384.793 1844.92 376.563 1790.03 391.431C1737.52 405.655 1686.41 432.975 1634.68 421.851C1578.05 409.677 1520.05 381.494 1493.41 327.657C1467.25 274.795 1490.58 209.228 1499.21 148.106C1507.22 91.3209 1504.41 28.1791 1541.76 -14.9039C1578.54 -57.3246 1636.72 -65.6439 1689.26 -71.1257C1734.12 -75.806 1773.12 -53.9035 1816.29 -43.5451Z",
    fill: "#B831BB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1631 41.1592C1581.33 72.4445 1567.79 151.729 1510.26 163.359C1452.18 175.097 1402.98 123.82 1349.64 98.0293C1289.27 68.8413 1214.97 58.7456 1178.09 2.75156C1138.64 -57.1257 1137.31 -134.597 1149.88 -205.19C1162.95 -278.64 1187.02 -358.891 1249.68 -399.38C1310.54 -438.703 1389.15 -406.595 1461.61 -406.618C1526.04 -406.638 1589.78 -422.333 1650.03 -399.508C1719.27 -373.279 1788.5 -334.842 1823.41 -269.554C1859.8 -201.505 1880.59 -109.932 1839.96 -44.3258C1799.34 21.2625 1696.27 0.0414759 1631 41.1592Z",
    fill: "#8936E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1949.94 105.48C1891.9 112.599 1848.35 56.7571 1795.84 31.0177C1735.35 1.37253 1651.93 2.29423 1619.26 -56.605C1586.37 -115.886 1614.92 -190.275 1637.62 -254.154C1658.4 -312.625 1692.56 -365.403 1742.22 -402.611C1789.8 -438.256 1848.32 -452.673 1907.65 -456.469C1966.39 -460.228 2027.81 -456.603 2076.83 -424.022C2125.01 -391.995 2154.98 -338.349 2169.6 -282.366C2182.96 -231.173 2170.17 -178.697 2154.03 -128.31C2138.97 -81.2639 2112.91 -41.0965 2080.42 -3.88225C2042.17 39.9419 2007.68 98.3995 1949.94 105.48Z",
    fill: "#3E23E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2172.51 546.939C2136.73 589.843 2077.65 598.492 2032.61 631.537C1977.3 672.113 1947.95 754.065 1879.78 761.703C1810.22 769.497 1741.34 723.324 1697.04 669.134C1655.31 618.104 1667.95 545.501 1650.94 481.817C1632.09 411.215 1552.16 337.381 1592.13 276.202C1634.05 212.022 1743.33 267.357 1812.56 234.421C1874.21 205.085 1893.42 110.195 1961.03 100.683C2030.27 90.9421 2094.26 140.803 2146.33 187.461C2199.22 234.857 2250.19 293.589 2255.35 364.421C2260.33 432.729 2216.37 494.339 2172.51 546.939Z",
    fill: "#E46B45"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1459.41 713.467C1443.82 764.191 1457.32 832.396 1411.12 861.004C1365.1 889.5 1301.54 852.991 1244.78 846.37C1185.43 839.449 1116.96 860.323 1071.44 821.39C1025.9 782.437 1038.33 715.75 1026.93 660.037C1016.02 606.74 991.95 554.022 1006.29 503.083C1021.98 447.331 1053.74 391.208 1109.14 367.988C1163.54 345.188 1227.52 372.576 1287.98 385.013C1344.15 396.566 1407.34 397.713 1448 437.686C1488.04 477.045 1492.7 535.638 1494.88 588.421C1496.75 633.487 1472.45 671.035 1459.41 713.467Z",
    fill: "#B831BB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1386.47 523.239C1358.35 471.712 1280.07 453.238 1272.06 395.088C1263.98 336.394 1318.24 290.497 1347.32 238.876C1380.23 180.454 1394.95 106.933 1453.15 73.621C1515.38 37.9986 1592.78 41.5213 1662.45 58.4839C1734.93 76.1328 1813.52 105.175 1850.01 170.248C1885.45 233.448 1848.48 309.897 1843.97 382.214C1839.95 446.518 1851.63 511.118 1825.08 569.821C1794.57 637.278 1751.87 703.967 1684.53 734.724C1614.33 766.781 1521.64 781.8 1458.7 737.145C1395.79 692.503 1423.42 590.96 1386.47 523.239Z",
    fill: "#8936E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1302.31 837.536C1298.84 779.156 1357.29 739.191 1386.27 688.392C1419.64 629.884 1423.94 546.569 1484.77 517.642C1546 488.529 1618.45 521.684 1680.78 548.339C1737.84 572.738 1788.38 610.132 1822.4 662.024C1855 711.735 1865.73 771.05 1865.8 830.496C1865.88 889.357 1858.42 950.427 1822.83 997.312C1787.85 1043.4 1732.43 1069.95 1675.64 1081.04C1623.72 1091.17 1572.14 1075.11 1522.86 1055.86C1476.85 1037.88 1438.4 1009.35 1403.29 974.602C1361.94 933.678 1305.76 895.606 1302.31 837.536Z",
    fill: "#3E23E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.783 1032.03C807.202 993.642 802.269 934.134 772.108 887.112C735.073 829.372 655.119 794.944 651.763 726.431C648.339 656.519 698.732 590.669 755.588 549.843C809.13 511.398 880.8 528.55 945.423 515.567C1017.07 501.173 1095.76 426.02 1154.32 469.736C1215.75 515.597 1153.68 621.197 1182.22 692.348C1207.64 755.721 1301.14 780.827 1306.4 848.905C1311.79 918.611 1258.02 979.361 1208.19 1028.41C1157.58 1078.23 1095.77 1125.42 1024.76 1126.14C956.272 1126.83 897.535 1079.1 847.783 1032.03Z",
    fill: "#E46B45"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M793.805 464.694C744.227 445.777 675.277 454.721 649.796 406.725C624.416 358.918 665.06 297.926 675.431 241.722C686.274 182.964 669.987 113.262 711.853 70.4266C753.741 27.5697 819.457 44.3943 875.804 36.7112C929.707 29.3613 983.905 8.84343 1033.78 26.5305C1088.37 45.8888 1142.26 81.2997 1161.76 138.116C1180.9 193.905 1149.33 255.925 1132.91 315.43C1117.65 370.712 1112.32 433.69 1069.73 471.61C1027.81 508.947 969.034 509.711 916.223 508.388C871.133 507.258 835.279 480.52 793.805 464.694Z",
    fill: "#B831BB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M988.453 404.532C1041.73 379.897 1065.36 303.013 1123.91 298.882C1183.01 294.712 1225.21 351.894 1274.79 384.332C1330.9 421.044 1403.28 440.615 1432.66 500.889C1464.07 565.344 1455.42 642.343 1433.88 710.732C1411.46 781.889 1377.27 858.377 1309.92 890.468C1244.51 921.635 1170.68 879.679 1098.82 870.38C1034.93 862.111 969.693 869.475 912.88 839.088C847.595 804.17 783.885 757.146 757.663 687.909C730.332 615.744 721.496 522.257 770.226 462.423C818.943 402.605 918.43 436.911 988.453 404.532Z",
    fill: "#8936E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M680.43 299.712C738.911 300.12 774.911 361.101 823.677 393.382C879.842 430.562 962.688 440.381 987.516 502.994C1012.5 566.013 974.617 636.111 943.886 696.538C915.756 751.85 875.093 799.795 821.058 830.305C769.294 859.533 709.398 866.301 650.078 862.433C591.342 858.603 530.902 847.107 486.479 808.49C442.813 770.529 419.996 713.474 412.704 656.076C406.036 603.589 425.478 553.196 447.961 505.302C468.954 460.586 499.963 424.105 536.967 391.379C580.544 352.841 622.258 299.305 680.43 299.712Z",
    fill: "#3E23E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.508 -166.712C557.508 -204.657 617.212 -205.632 666.131 -232.608C726.2 -265.732 765.855 -343.226 834.44 -342.03C904.425 -340.81 966.787 -286.159 1003.75 -226.72C1038.56 -170.747 1016.69 -100.372 1025.36 -35.0302C1034.97 37.4108 1104.74 120.915 1057.24 176.443C1007.4 234.696 906.15 165.762 833.263 189.518C768.344 210.678 737.091 302.308 668.815 303.043C598.904 303.795 541.854 246.115 496.222 193.146C449.868 139.339 406.876 74.5386 410.874 3.63087C414.728 -64.7492 466.243 -120.192 516.508 -166.712Z",
    fill: "#E46B45"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1358.25 42.1946C1363.36 -10.6235 1336.46 -74.74 1375.99 -112.027C1415.37 -149.168 1484.95 -126.137 1541.89 -131.028C1601.42 -136.142 1664.32 -170.314 1716.71 -141.294C1769.14 -112.259 1770.33 -44.4336 1792.67 7.86336C1814.04 57.8925 1848.18 104.717 1844.34 157.496C1840.14 215.263 1820.27 276.612 1770.65 310.464C1721.93 343.704 1653.76 329.693 1592.03 329.627C1534.68 329.566 1472.54 341.108 1424.7 310.095C1377.58 279.558 1361.27 223.089 1348.56 171.814C1337.7 128.036 1353.98 86.3797 1358.25 42.1946Z",
    fill: "#B831BB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1467.84 213.945C1505.71 258.792 1586.11 261.201 1605.6 316.567C1625.28 372.45 1581.33 428.29 1563.18 484.691C1542.65 548.524 1542.96 623.505 1492.62 667.804C1438.8 715.176 1362.26 727.237 1290.6 724.582C1216.05 721.819 1133.24 709.117 1084.45 652.677C1037.06 597.861 1057.96 515.554 1047.88 443.8C1038.93 379.998 1014.54 319.047 1028.79 256.214C1045.16 184.011 1073.63 110.118 1133.44 66.4881C1195.78 21.013 1283.59 -12.2785 1354.2 18.8564C1424.78 49.9829 1418.06 155.004 1467.84 213.945Z",
    fill: "#8936E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1487.3 -110.842C1502.4 -54.3432 1453.14 -3.47275 1434.93 52.1035C1413.96 116.113 1426.45 198.599 1372.65 239.13C1318.5 279.923 1240.87 261.963 1174.46 248.341C1113.67 235.873 1056.67 209.366 1012.93 165.347C971.032 123.177 948.635 67.2148 936.647 8.99068C924.777 -48.6614 919.848 -109.987 945.315 -163.054C970.349 -215.218 1019.32 -252.337 1072.73 -274.577C1121.58 -294.914 1175.32 -289.519 1227.46 -280.529C1276.14 -272.135 1319.53 -251.9 1360.9 -224.889C1409.6 -193.081 1472.28 -167.043 1487.3 -110.842Z",
    fill: "#3E23E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1893.62 -392.49C1941.07 -363.01 1957.83 -305.698 1996.8 -265.675C2044.66 -216.53 2129.89 -198.825 2146.91 -132.374C2164.28 -64.5669 2128.1 10.0465 2080.58 61.4392C2035.83 109.835 1962.18 107.396 1901.47 133.067C1834.16 161.528 1772.13 250.927 1706 219.834C1636.63 187.216 1676.27 71.3186 1634.05 7.33137C1596.44 -49.6609 1499.81 -55.5187 1481.01 -121.16C1461.76 -188.372 1502.26 -258.666 1541.25 -316.703C1580.85 -375.657 1631.94 -434.281 1701.37 -449.215C1768.33 -463.616 1835.44 -428.633 1893.62 -392.49Z",
    fill: "#E46B45"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-193.747 702.195C-188.642 649.376 -215.536 585.26 -176.006 547.973C-136.633 510.832 -67.0519 533.863 -10.109 528.972C49.4223 523.858 112.318 489.686 164.715 518.706C217.139 547.741 218.328 615.566 240.666 667.863C262.035 717.892 296.18 764.717 292.341 817.496C288.138 875.263 268.272 936.612 218.652 970.464C169.929 1003.7 101.76 989.693 40.0315 989.627C-17.316 989.566 -79.4575 1001.11 -127.305 970.095C-174.416 939.558 -190.726 883.089 -203.443 831.814C-214.3 788.036 -198.018 746.38 -193.747 702.195Z",
    fill: "#B831BB"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-84.1612 873.945C-46.2892 918.792 34.1066 921.201 53.6041 976.567C73.2841 1032.45 29.327 1088.29 11.1846 1144.69C-9.34805 1208.52 -9.04053 1283.5 -59.3766 1327.8C-113.203 1375.18 -189.742 1387.24 -261.396 1384.58C-335.949 1381.82 -418.763 1369.12 -467.552 1312.68C-514.937 1257.86 -494.042 1175.55 -504.115 1103.8C-513.072 1040 -537.456 979.047 -523.209 916.214C-506.837 844.011 -478.374 770.118 -418.56 726.488C-356.216 681.013 -268.411 647.721 -197.804 678.856C-127.216 709.983 -133.935 815.004 -84.1612 873.945Z",
    fill: "#8936E1"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-64.7014 549.158C-49.6001 605.657 -98.8623 656.527 -117.069 712.104C-138.038 776.113 -125.555 858.599 -179.352 899.13C-233.498 939.924 -311.129 921.963 -377.539 908.341C-438.327 895.873 -495.333 869.366 -539.07 825.347C-580.968 783.177 -603.365 727.215 -615.353 668.991C-627.223 611.339 -632.152 550.013 -606.685 496.946C-581.651 444.783 -532.68 407.663 -479.266 385.423C-430.422 365.086 -376.678 370.481 -324.539 379.471C-275.859 387.866 -232.465 408.1 -191.105 435.111C-142.398 466.919 -79.7229 492.957 -64.7014 549.158Z",
    fill: "#3E23E7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_1114_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.619 267.51C389.071 296.99 405.831 354.302 444.804 394.325C492.659 443.47 577.891 461.175 594.911 527.626C612.277 595.433 576.104 670.047 528.584 721.439C483.834 769.835 410.18 767.396 349.47 793.067C282.165 821.528 220.131 910.927 154.001 879.834C84.6258 847.216 124.268 731.319 82.0485 667.331C44.4444 610.339 -52.1919 604.481 -70.9911 538.84C-90.2404 471.628 -49.7379 401.334 -10.7529 343.297C28.8488 284.343 79.9424 225.719 149.375 210.785C216.332 196.384 283.443 231.367 341.619 267.51Z",
    fill: "#E46B45"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1919,
    height: 604,
    stroke: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1114_3224",
    x: -169.664,
    y: -197.842,
    width: 698.719,
    height: 696.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1114_3224",
    x: -508.203,
    y: -545.017,
    width: 919.364,
    height: 784.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1114_3224",
    x: -46.6783,
    y: -583.736,
    width: 770.832,
    height: 763.768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1114_3224",
    x: -69.9443,
    y: -26.6178,
    width: 874.654,
    height: 863.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1114_3224",
    x: 1381.36,
    y: -171.773,
    width: 698.719,
    height: 696.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1114_3224",
    x: 1042.83,
    y: -518.947,
    width: 919.364,
    height: 784.025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_1114_3224",
    x: 1504.35,
    y: -557.666,
    width: 770.832,
    height: 763.768,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1114_3224",
    x: 1481.08,
    y: -0.547974,
    width: 874.654,
    height: 863.113,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1114_3224",
    x: 901.853,
    y: 259.209,
    width: 693.132,
    height: 712.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1114_3224",
    x: 1171.25,
    y: -53.9119,
    width: 793.97,
    height: 918.978,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1114_3224",
    x: 1202.16,
    y: 406.321,
    width: 763.644,
    height: 777.848,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1114_3224",
    x: 551.598,
    y: 356.23,
    width: 855.177,
    height: 869.914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1114_3224",
    x: 541.59,
    y: -80.4718,
    width: 726.138,
    height: 689.198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_1114_3224",
    x: 635.404,
    y: 198.666,
    width: 917.821,
    height: 803.143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_1114_3224",
    x: 311.374,
    y: 199.709,
    width: 784.259,
    height: 763.717,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_1114_3224",
    x: 310.615,
    y: -442.044,
    width: 863.032,
    height: 845.094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_1114_3224",
    x: 1244.89,
    y: -252.848,
    width: 699.751,
    height: 685.462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_1114_3224",
    x: 924.421,
    y: -93.3015,
    width: 786.148,
    height: 918.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_1114_3224",
    x: 826.944,
    y: -388.551,
    width: 763.19,
    height: 752.821,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_1114_3224",
    x: 1376.06,
    y: -552.533,
    width: 875.272,
    height: 878.845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_1114_3224",
    x: -307.112,
    y: 407.152,
    width: 699.751,
    height: 685.462,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_1114_3224",
    x: -627.579,
    y: 566.699,
    width: 786.148,
    height: 918.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_1114_3224",
    x: -725.056,
    y: 271.449,
    width: 763.19,
    height: 752.821,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_1114_3224",
    x: -175.936,
    y: 107.467,
    width: 875.272,
    height: 878.845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_1114_3224"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1114_3224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 605,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTdBanner);
export default __webpack_public_path__ + "static/media/TD_Banner.8d998f5c275505911d0683f21c545d15.svg";
export { ForwardRef as ReactComponent };